import { Table } from "components";
import { useEffect, useState, useCallback } from "react";
import { StoresPopup } from "popups/Stores/Stores";
import { getRowIds } from "helpers/data/dataHandling";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { getStores } from "redux/slices/Stores";
import { updatePreferredBrandField, getPreferredBrandDetails } from "redux/slices/PreferredBrands";
import { Badge } from "react-bootstrap";

export function Stores() {
    const dispatch = useAppDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [canReloadStores, setCanReloadStores] = useState(true);
    const stores = useAppSelector((state: RootState) => state.stores);
    const preferredBrands: any = useAppSelector((state: RootState) => state.preferredBrands);
    const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
    const columns = [
        {
            Header: "Name",
            accessor: "name",
            defaultCanSort: true,
            width: 200,
        },
        {
            Header: "Store Status",
            accessor: "storeId",
            defaultCanSort: true,
            width: 200,
            Cell: (row: any) => {
                return row.cell.row.original.connected === true ? (<Badge className="me-1 badge-outline-success">Online</Badge>) : (<Badge className="me-1 badge-outline-danger">Offline</Badge>)
            },
        },
        {
            Header: "Status",
            accessor: "status",
            width: 900,
            Cell: (row: any) => <>
                {preferredBrands.stores.includes(row.cell.row.original.id as never) ? (<Badge className="me-1 badge-outline-success">Sent</Badge>) : (<Badge className="me-1 badge-outline-warning">Pending</Badge>)}
            </>,
        },
    ];

    useEffect(() => {
        canReloadStores && getStoresTable();
    }, [preferredBrands.stores, preferredBrands.storesList]);

    function getStoresTable() {
        let storeList: any[] = [...preferredBrands.stores];
        preferredBrands.storesList.map((store: any) => {
            if (!storeList.includes(store)) storeList.push(store);
        });
        let storesTable: any[] = [];
        dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then((res) => {
            res.data.map((store: any) => {
                if (storeList.includes(store.id as never)) storesTable.push(store);
            });
            dispatch(updatePreferredBrandField({ key: "storesTable", value: storesTable }));
        });
    }

    async function storesPopupSave() {
        let selectedStores: any[] = [];
        let deseledStores: any[] = [];
        let storeList: any[] = [...preferredBrands.stores];
        let selectedStoresIds: any[] = [];
        selectedStores = getRowIds(stores.selectedRows);
        deseledStores = getRowIds(stores.deselectedRows);
        if (stores.selectAllFilter) {
            await dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then(async (res) => {
                const storeIds = res.data.map((i: any) => i.id);
                await storeIds.forEach((store: number) => {
                    if (!deseledStores.includes(store)) selectedStoresIds.push(store);
                });
            });
        } else {
            selectedStores.forEach(async (store: number) => selectedStoresIds.push(store));
        }
        selectedStoresIds.forEach((store: number) => {
            if (!storeList.includes(store)) storeList.push(store);
        });
        dispatch(updatePreferredBrandField({ key: "storesList", value: storeList }));
        setShowPopup(false);
    }

    const selectedRows = useCallback((pageIndex:any) => {
        dispatch(updatePreferredBrandField({ key: "selectedStoresRows", value: pageIndex }));
    }, []);

    async function handleDelete() {
        setCanReloadStores(false);
        let preferredBrandIds = await preferredBrands.selectedStoresRows.map((row: any) => preferredBrands.storesTable[parseInt(row)].id);

        let storesList: any[] = [];
        preferredBrands.storesList.map((store: any) => {
            if (!preferredBrandIds.includes(store)) storesList.push(store);
        });
        await dispatch(updatePreferredBrandField({ key: "storesList", value: storesList }));
        await dispatch(updatePreferredBrandField({ key: "stores", value: storesList }));

        let storesTable: any[] = [];
        preferredBrands.storesTable.map((store: any) => {
            if (!preferredBrandIds.includes(store.id)) storesTable.push(store);
        });
        await dispatch(updatePreferredBrandField({ key: "storesTable", value: storesTable }));

        setCanReloadStores(true);
    }

    return (
        <>
            <StoresPopup show={showPopup} onClose={() => setShowPopup(false)} onSave={storesPopupSave} />
            <Table
                maxHeight={450}
                pageSize={100}
                isSortable={true}
                pagination={true}
                isSelectable={true}
                isSearchable={true}
                columns={columns}
                loading={preferredBrands.loading}
                selectedRows={selectedRows}
                data={preferredBrands.storesTable}
                addNewRow={() => setShowPopup(true)}
                reloadTableRows={() => dispatch(getPreferredBrandDetails({ ids: [preferredBrands.id], loadDetails: ['Manufacturers', 'Stock', 'Stores'] }))}
                removeRows={handleDelete}
            />
        </>
    );
}